<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="content table-responsive table-full-width">
                          <table class="table table-hover table-striped">
                                <thead>
                                    <tr>
                                        <th *ngFor="let cell of tableData1.headerRow">{{ cell }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of tableData1.dataRows">
                                        <td>{{row.date}}</td>
                                        <td>{{row.attempts}}</td>
                                        <td>{{row.attemptsUsed}}</td>
                                        <td>{{row.attemptsRemaining}}</td>
                                        <td>{{ row.expiry}}</td>
                                        <td>{{row.active ? 'Active' : 'Expired'}}</td>
                                    </tr>
                                </tbody>
                          </table>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
